import Header from "./header";

const createHeader = () => {
    return () => <Header />;
};

export { createHeader };
